function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient",
  y1: 0.5,
  x2: 1,
  y2: 0.5,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#da0000"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#9f0000"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_60",
  "data-name": "Group 60",
  transform: "translate(-3151.127 -3154.264)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_58",
  "data-name": "Path 58",
  d: "M3176.827,3154.556a8.528,8.528,0,0,1,5.756.478h0a8.543,8.543,0,0,0,7.089,0h0a8.547,8.547,0,0,1,10.5,2.814h0a8.537,8.537,0,0,0,6.139,3.544h0a8.545,8.545,0,0,1,7.687,7.687h0a8.539,8.539,0,0,0,3.544,6.139h0a8.544,8.544,0,0,1,2.814,10.5h0a8.543,8.543,0,0,0,0,7.089h0a8.543,8.543,0,0,1-2.814,10.5h0a8.537,8.537,0,0,0-3.544,6.139h0a8.543,8.543,0,0,1-7.687,7.687h0a8.546,8.546,0,0,0-6.139,3.544h0a8.544,8.544,0,0,1-10.5,2.814h0a8.543,8.543,0,0,0-7.089,0h0a8.542,8.542,0,0,1-10.5-2.814h0a8.547,8.547,0,0,0-6.139-3.544h0a8.542,8.542,0,0,1-7.687-7.687h0a8.539,8.539,0,0,0-3.544-6.139h0a8.543,8.543,0,0,1-2.814-10.5h0a8.543,8.543,0,0,0,0-7.089h0a8.544,8.544,0,0,1,2.814-10.5h0a8.54,8.54,0,0,0,3.544-6.139h0a8.545,8.545,0,0,1,7.687-7.687h0a8.538,8.538,0,0,0,6.139-3.544h0A8.525,8.525,0,0,1,3176.827,3154.556Z",
  fill: "url(#linear-gradient)"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_35",
  "data-name": "Ellipse 35",
  cx: 29.15,
  cy: 29.15,
  r: 29.15,
  transform: "translate(3156.978 3160.114)",
  fill: "none",
  stroke: "#fbb03b",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_59",
  "data-name": "Group 59"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_59",
  "data-name": "Path 59",
  d: "M3196.592,3172.795v-3.114h-21.207v3.114h-8.2v6.8a9.207,9.207,0,0,0,8.917,9.189,10.668,10.668,0,0,0,7.728,6.592v3.306a7.746,7.746,0,0,0-4.909,4.37h14.138a7.738,7.738,0,0,0-4.909-4.37v-3.306a10.666,10.666,0,0,0,7.729-6.592,9.207,9.207,0,0,0,8.917-9.189v-6.8Zm-21.207,11.906a5.208,5.208,0,0,1-4.2-5.1v-2.8h4.2Zm13.688,3.783h-3.723V3178.2h-2.445v-2.878h6.168Zm11.721-8.886a5.209,5.209,0,0,1-4.2,5.1v-7.9h4.2Z",
  fill: "#fbb03b"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_58",
  "data-name": "Group 58"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_60",
  "data-name": "Path 60",
  d: "M3187.3,3207.752h.588l-.294-.731Z",
  fill: "#fbb03b"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_61",
  "data-name": "Path 61",
  d: "M3193.578,3206.877a.653.653,0,1,0,.618.653A.613.613,0,0,0,3193.578,3206.877Z",
  fill: "#fbb03b"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_62",
  "data-name": "Path 62",
  d: "M3181.421,3206.877a.653.653,0,1,0,.617.653A.613.613,0,0,0,3181.421,3206.877Z",
  fill: "#fbb03b"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_63",
  "data-name": "Path 63",
  d: "M3174.238,3207.752h.588l-.294-.731Z",
  fill: "#fbb03b"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_64",
  "data-name": "Path 64",
  d: "M3170.813,3205.4v4.283h30.629V3205.4Zm4.382,3.276-.18-.445h-.966l-.18.445h-.66l1.009-2.286h.637l1.013,2.286Zm1.657.046a1.806,1.806,0,0,1-.964-.252l.213-.477a1.437,1.437,0,0,0,.754.226c.267,0,.372-.076.372-.187,0-.362-1.3-.1-1.3-.946,0-.408.333-.741,1.013-.741a1.7,1.7,0,0,1,.829.2l-.2.479a1.355,1.355,0,0,0-.633-.175c-.272,0-.369.09-.369.205,0,.349,1.3.088,1.3.93C3177.864,3208.379,3177.531,3208.719,3176.852,3208.719Zm2.11,0a1.805,1.805,0,0,1-.964-.252l.213-.477a1.44,1.44,0,0,0,.754.226c.268,0,.372-.076.372-.187,0-.362-1.3-.1-1.3-.946,0-.408.333-.741,1.013-.741a1.7,1.7,0,0,1,.829.2l-.2.479a1.354,1.354,0,0,0-.633-.175c-.271,0-.369.09-.369.205,0,.349,1.3.088,1.3.93C3179.974,3208.379,3179.641,3208.719,3178.962,3208.719Zm2.459,0a1.191,1.191,0,1,1,1.271-1.189A1.194,1.194,0,0,1,3181.421,3208.719Zm2.78-.537a.678.678,0,0,0,.539-.267l.412.372a1.213,1.213,0,0,1-.984.432,1.19,1.19,0,1,1,0-2.377,1.215,1.215,0,0,1,.984.43l-.412.372a.68.68,0,0,0-.539-.267.653.653,0,0,0,0,1.3Zm1.881.491h-.646v-2.286h.646Zm2.17,0-.179-.445h-.966l-.18.445h-.66l1.009-2.286h.636l1.013,2.286Zm2.787,0h-2.047v-.406l1.152-1.368h-1.123v-.512h1.969v.405l-1.153,1.368h1.2Zm.928,0h-.646v-2.286h.646Zm1.611.046a1.191,1.191,0,1,1,1.271-1.189A1.194,1.194,0,0,1,3193.578,3208.719Zm3.783-.046h-.533l-1.008-1.218v1.218h-.634v-2.286h.532l1.009,1.218v-1.218h.634Zm1.1,0h-.646v-2.286h.646Z",
  fill: "#fbb03b"
}))));

var SvgFirstPlaceAssociation = function SvgFirstPlaceAssociation(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFirstPlaceAssociation, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/first-place-association.a90c922a.svg";
export { ForwardRef as ReactComponent };